import { styled, Typography, Button, Grid } from '@mui/material';
import {GLOBAL} from "../../../../../../utils/constants";

export const MuiGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  marginTop:'10px'
}));

export const MuiSaveButton = styled(Button)(({ theme }) => ({
  marginLeft: 16,
  borderRadius:20,
  background: theme.palette.primary.main,
  height:'38px',
  width:'143px',
  padding:'10px 24px 10px 16px',
  gap:8
}));

export const MuiSaveAndViewButton = styled(Button)(({ theme }) => ({
  borderRadius:20,
  marginLeft:24,
  height:'38px',
  padding:'10px 24px 10px 16px',
  gap:8,
  background: theme.palette.primary.main,
}));

export const MuiActionTypography = styled(Typography)(({ theme }) => ({
  color: '#FFFFFF',
  textAlign:'center',
  fontFamily: 'Montserrat',
  fontSize: 14,
  fontWeight: 500,
  letterSpacing: 0.25
}));

export const saveAndViewButtonStyles = {
  borderRadius:20,
  marginLeft:24,
  background: localStorage.getItem('colorPrimary'),
  height:'38px',
  padding:'10px 24px 10px 16px',
  gap:8
}

export const iconCommonStyles = {
  color:'white'
}
